import script from "./logoutComponent.vue?vue&type=script&lang=ts"
export * from "./logoutComponent.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__